module.exports = __webpack_public_path__ + "img/282.bbf631d5.gif";